import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const TwoLevel = ({ menu, pathname }) => {
  const [active, setActive] = useState(false);

  const { name, path, subMenu, highlight, subHighlight } = menu;

  const subMenuPaths = subMenu.map((sub) => sub.path);

  useEffect(() => {
    if (
      subMenuPaths.includes(pathname) ||
      subMenuPaths.includes("/" + pathname.split("/")[1]) ||
      highlight.includes(pathname) ||
      subHighlight.includes(pathname.split("/").slice(0, 3).join("/"))
    ) {
      setActive(true);
    } else {
      setActive(false);
    }
  }, [pathname]);

  const handleClick = (e) => {
    e.stopPropagation();
    setActive((prev) => !prev);
  };
  return (
    <li
      id={`collapse-menu-main ${name}-toggle-7`}
      className={`menu-item menu-item-submenu ${active ? "menu-item-open" : ""
        } `}
      data-menu-toggle="hover"
      onClick={handleClick}

    >
      <a className="menu-link menu-toggle">
        <i className="menu-bullet menu-bullet-line">
          <span></span>
        </i>
        <span className="menu-text">{name}</span>
        <i className="menu-arrow"></i>
      </a>
      <div className="menu-submenu">
        <i className="menu-arrow"></i>
        <ul className="menu-subnav">
          {subMenu.map((submenuItem, index) => (
            <li
              key={index}
              className={`menu-item ${submenuItem.path === pathname ||
                  submenuItem.highlight.includes(pathname) ||
                  submenuItem.subHighlight.includes(
                    pathname.split("/").slice(0, 3).join("/")
                  )
                  ? "menu-item-open"
                  : ""
                }`}
            >
              <Link to={submenuItem.path} className="menu-link" >
                <i className="menu-bullet menu-bullet-line">
                  <span></span>
                </i>
                <span className="menu-text">{submenuItem.name}</span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </li>
  );
};

export default TwoLevel;
